import * as React from 'react';
import {classNames} from '@shopify/react-utilities/styles';
import {NOOP} from 'components/UIKit/utilities';
import {NavItemData} from '../../types';
import {MegaNavItem} from '../MegaNavItem';
import * as styles from './MegaNav.scss';

interface MegaNavProps {
  openNavs: string[];
  onActiveNavs: (itemPath) => any;
  shopNavItems: NavItemData[];
  infoNavItems: NavItemData[];
}

function getEmptyNavItemData(items) {
  return {
    url: '',
    title: '',
    children: items,
    internalName: '',
    pluralizedTitle: '',
  };
}

export class MegaNav extends React.Component<MegaNavProps> {
  refFns: any;
  listRefs: any;

  constructor(props) {
    super(props);

    this.refFns = {};
    this.listRefs = {};
  }

  setRef = (refName, element) => {
    this.listRefs[refName] = element;
  };

  setMenuRef = (refName) => {
    if (this.refFns[refName]) {
      return this.refFns[refName];
    }

    this.refFns[refName] = this.setRef.bind(this, refName);
    return this.refFns[refName];
  };

  resetListScroll = () => {
    const {openNavs} = this.props;

    Object.keys(this.listRefs).forEach((list) => {
      if (openNavs.includes(list)) {
        return;
      }
      this.listRefs[list].scrollTop = 0;
    });
  };

  shouldComponentUpdate(nextProps) {
    return (
      nextProps.openNavs !== this.props.openNavs ||
      nextProps.shopNavItems !== this.props.shopNavItems
    );
  }

  componentDidUpdate() {
    this.resetListScroll();
  }

  renderMenu(item: NavItemData, itemPath: string[] = [], isPrimary = false) {
    const {openNavs} = this.props;
    const isOpen = isPrimary || openNavs.includes(item.internalName);
    const tabIndex = isOpen ? 0 : -1;

    const list = (
      <ul
        ref={this.setMenuRef(item.internalName)}
        className={isPrimary ? styles.baseList : styles.list}
      >
        {item.children.map((child) => {
          const {onActiveNavs = NOOP} = this.props;
          const subPath =
            child.children.length > 0 ? itemPath.concat(child.internalName) : itemPath;

          return (
            <li key={child.internalName} className={styles.listItem}>
              <MegaNavItem
                item={child}
                active={openNavs.includes(child.internalName)}
                tabIndex={tabIndex}
                itemPath={subPath}
                onActive={onActiveNavs}
              />
              {child.children.length ? this.renderMenu(child, subPath) : null}
            </li>
          );
        })}
      </ul>
    );

    return isPrimary ? (
      list
    ) : (
      <div className={classNames(styles.listContainer, {[styles.open]: isOpen})}>{list}</div>
    );
  }

  render() {
    const {shopNavItems, infoNavItems} = this.props;

    return (
      <div className={styles.baseListContainer}>
        {this.renderMenu(getEmptyNavItemData(shopNavItems), [], true)}
        {this.renderMenu(getEmptyNavItemData(infoNavItems), [], true)}
      </div>
    );
  }
}
